import React from 'react';
import { useTranslation } from '@rbx/intl';

const DErrorMessage: React.FunctionComponent = () => {
  const { translate } = useTranslation();
  return <React.Fragment>{translate('Error.UnexpectedError')}</React.Fragment>;
};

export default DErrorMessage;
